export default {"src":"/_next/static/media/instagram.f48e85a1.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};